import { useTranslation } from "react-i18next";import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  ReferenceArea } from
'recharts';

export const TemperatureChart = ({
  data,
  minThreshold,
  maxThreshold,
  height = 300,
  showThresholdBands = true
}) => {const { t } = useTranslation("ezparcel");
  // Find min/max values for Y axis
  const allTemps = data.map((d) => d.temp);
  const dataMin = Math.min(...allTemps);
  const dataMax = Math.max(...allTemps);
  const yMin = Math.min(dataMin, minThreshold) - 2;
  const yMax = Math.max(dataMax, maxThreshold) + 2;

  const CustomTooltip = ({ active, payload, label }) => {const { t } = useTranslation("ezparcel");
    if (active && payload && payload.length) {
      const temp = payload[0].value;
      const inRange = temp >= minThreshold && temp <= maxThreshold;

      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="font-medium text-sm">{label}</p>
          <p className={`text-lg font-bold font-mono ${inRange ? 'text-emerald-600' : 'text-red-600'}`}>
            {temp.toFixed(1)}{t("c", "\xB0C")}
          </p>
          {!inRange &&
          <p className="text-xs text-red-600 mt-1">{t("outOfRange", "\u26A0\uFE0F Out of range (")}
            {minThreshold}{t("c", "\xB0C -")}{maxThreshold}{t("c", "\xB0C)")}
          </p>
          }
        </div>);

    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
        
        {/* Safe zone band */}
        {showThresholdBands &&
        <ReferenceArea
          y1={minThreshold}
          y2={maxThreshold}
          fill="#10b981"
          fillOpacity={0.1} />

        }
        
        {/* Danger zones */}
        {showThresholdBands &&
        <>
            <ReferenceArea
            y1={yMin}
            y2={minThreshold}
            fill="#ef4444"
            fillOpacity={0.1} />
          
            <ReferenceArea
            y1={maxThreshold}
            y2={yMax}
            fill="#ef4444"
            fillOpacity={0.1} />
          
          </>
        }
        
        <XAxis
          dataKey="time"
          stroke="hsl(var(--muted-foreground))"
          fontSize={12} />
        
        <YAxis
          domain={[yMin, yMax]}
          stroke="hsl(var(--muted-foreground))"
          fontSize={12}
          tickFormatter={(value) => `${value}°C`} />
        
        <Tooltip content={<CustomTooltip />} />
        
        {/* Threshold lines */}
        <ReferenceLine
          y={maxThreshold}
          stroke="#ef4444"
          strokeDasharray="5 5"
          label={{ value: `Max ${maxThreshold}°C`, position: 'right', fill: '#ef4444', fontSize: 11 }} />
        
        <ReferenceLine
          y={minThreshold}
          stroke="#3b82f6"
          strokeDasharray="5 5"
          label={{ value: `Min ${minThreshold}°C`, position: 'right', fill: '#3b82f6', fontSize: 11 }} />
        
        
        {/* Temperature line */}
        <Line
          type="monotone"
          dataKey="temp"
          stroke="#06b6d4"
          strokeWidth={2}
          dot={(props) => {
            const { cx, cy, payload } = props;
            const inRange = payload.temp >= minThreshold && payload.temp <= maxThreshold;
            return (
              <circle
                cx={cx}
                cy={cy}
                r={4}
                fill={inRange ? '#10b981' : '#ef4444'}
                stroke={inRange ? '#10b981' : '#ef4444'} />);


          }}
          activeDot={{ r: 6, fill: '#06b6d4' }} />
        
      </LineChart>
    </ResponsiveContainer>);

};